import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

export const useTeamOptions = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const options = useUnsafeMemo(() => {
    const teamsById = filtersOptionsData.teams.teams.reduce((acc, team) => {
      acc.set(team.id, team.name)
      return acc
    }, new Map<number, string>())

    filtersOptionsData.teams.historicalTeams.forEach((team) => {
      if (!teamsById.has(team.id)) {
        teamsById.set(team.id, team.name)
      }
    })

    const teamOptions = Array.from(teamsById).map(([id, name]) => ({
      label: name,
      value: id,
    }))

    return orderBy(teamOptions, (option) => option.label, 'asc')
  }, [filtersOptionsData])

  return options
}
